import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShareExpiredPage, isExpiredError } from "@/components/ShareExpiry";
import { AnalysisDoc, fetchPublicAnalysis } from "@/components/quality/AnalysisDoc";

export default function PublicAnalysis() {
  const { token } = useParams(); const [d, setD] = useState(null); const [err, setErr] = useState(null);
  useEffect(() => { fetchPublicAnalysis(token).then(setD).catch((e) => setErr(isExpiredError(e) ? "expired" : true)); }, [token]);
  if (err === "expired") return <ShareExpiredPage />;
  if (err) return <div className="min-h-screen flex items-center justify-center text-sm text-[#A8A29E]" style={{ background: "#F3F1EC" }} data-testid="pub-analysis-error">Analysen blev ikke fundet.</div>;
  if (!d) return <div className="min-h-screen flex items-center justify-center text-[#A8A29E]" style={{ background: "#FBFAF8" }}>Indlæser…</div>;
  return (
    <div className="min-h-screen" style={{ background: "#FBFAF8", color: "#1A1919", fontFamily: "Manrope, sans-serif" }} data-testid="pub-analysis">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <AnalysisDoc d={d} isIndkob={d.report_type === "indkob_reklamation"} pub kicker="BSM A/S · Deling" />
      </div>
    </div>
  );
}
